import {
  TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from 'react-redux';

import type { RootState, AppDispatch } from '../redux';
export type { RootState, AppDispatch } from '../redux';

// Typed version of useDispatch and useSelector
export const useDispatch: () => AppDispatch = useReduxDispatch;
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

// Export actions/selectors root
export { actions } from '../redux';
